import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import "./styles.css";

import { Paths } from "components/common/navigation";
import log from "loglevel";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { ACTION_STATES } from "../../core/actions";

function SSOReturn({ ssoReturnVerify, authenticated, redirectPath, authStatus }) {
    useEffect(() => {
        ssoReturnVerify();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    log.debug("login status", authenticated, redirectPath, authStatus);
    if (authenticated) {
        return <Navigate to={redirectPath ? redirectPath : Paths.ADVERTISING} />;
    }
    const isLoading = authStatus === ACTION_STATES.SEND || authStatus === ACTION_STATES.NO_REQUEST;
    return (
        <div>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={"ssoContainer"}>
                    <div>
                        {isLoading && "Please wait, verifying your SSO credentials"}
                        {authStatus === ACTION_STATES.FAILED && "There was a problem verifying your SSO credentials"}
                    </div>
                </div>
            </Container>
        </div>
    );
}

SSOReturn.propTypes = {
    ssoReturnVerify: PropTypes.func.isRequired,
    authenticated: PropTypes.bool.isRequired,
    redirectPath: PropTypes.string,
    authStatus: PropTypes.string.isRequired,
};

export default SSOReturn;
